import {useLottie, useLottieInteractivity} from '@novemberfiveco/lottie-react-light'
import ky from 'ky'
import React from 'react'
import {useInView} from 'react-intersection-observer'

import Image from '@/components/image'
import type {ImageSource} from '@/types/image'

type Props = {
    animationUrl: string
    endFrame: number
    placeholderImage: ImageSource
}

const ScrollAnimation = ({animationUrl, endFrame, placeholderImage}: Props) => {
    const [animationData, setAnimationData] = React.useState<unknown>()
    const [animationRef, inView] = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    React.useEffect(() => {
        async function fetchData() {
            const data = await ky.get(animationUrl).json()
            setAnimationData(data)
        }

        if (inView && !animationData) {
            try {
                fetchData()
            } catch (error) {
                console.error(error)
            }
        }
    }, [inView, animationUrl, animationData])

    return (
        <div ref={animationRef}>
            {animationData ? (
                <LottieScrollAnimation animationData={animationData} endFrame={endFrame} />
            ) : (
                <Image image={placeholderImage} />
            )}
        </div>
    )
}

type LottieScrollAnimationProps = {
    animationData: any
    endFrame: number
}

const LottieScrollAnimation = ({animationData, endFrame}: LottieScrollAnimationProps) => {
    const lottieObj = useLottie({animationData})
    const lottieAnimation = useLottieInteractivity({
        lottieObj,
        mode: 'scroll',
        actions: [
            {
                visibility: [0.1, 0.9],
                type: 'seek',
                frames: [0, endFrame],
            },
        ],
    })

    return lottieAnimation
}

export default ScrollAnimation
